import { styled } from "@mui/material/styles";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";
import { grey, lightBlue } from "@mui/material/colors";

export const CustomToggleButtonGroup = styled(ToggleButtonGroup)(
  ({ theme }) => ({
    backgroundColor: grey["100"],
    borderRadius: 12,
    border: "none",
    "& .MuiToggleButton-root": {
      color: theme.palette.text.secondary,
      "&.Mui-selected": {
        borderRadius: 12,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
      },
      "&:hover": {
        borderRadius: 12,
        backgroundColor: lightBlue["100"],
        color: grey["800"],
      },
    },
  })
);

export const CustomToggleButton = styled(ToggleButton)(({ theme }) => ({
  borderRadius: 12,
  margin: 5,
  border: "none",
  "&.Mui-selected": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));
